import { ailos } from "@/banks/ailos";
import { Banco, IGerarRemessa } from "./types/Boletos";
import { bradesco } from "@/banks/bradesco";
import { sicredi } from "@/banks/sicredi";
import { sicoob } from "@/banks/sicoob";
import { bancoBrasil } from "./banks/banco-brasil";

export function remessa({ banco, dados }: IGerarRemessa) {
  if (banco === Banco.AILOS) {
    return ailos.gerarRemessa({ banco, dados });
  }

  if (banco === Banco.BRADESCO) {
    return bradesco.gerarRemessa({ banco, dados });
  }

  if (banco === Banco.SICREDI) {
    return sicredi.gerarRemessa({ banco, dados });
  }

  if (banco === Banco.SICOOB) {
    return sicoob.gerarRemessa({ banco, dados });
  }

  if (banco === Banco.BANCO_BRASIL) {
    return bancoBrasil.gerarRemessa({ banco, dados });
  }
}
